/**
 * CodeSkin sitewide AJAX add-to-cart: toast + badge only (no /cart redirect, no drawer).
 */
(function () {
  var lastCart = null;
  var pendingKeys = Object.create(null);

  window.__codeskinCartActive = true;

  window.codeskinCartStrings = window.codeskinCartStrings || {
    added: 'Added to your bag',
    error: 'Could not add to bag',
  };

  function getCartJsUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.indexOf('.js') === base.length - 3 ? base : base.replace(/\/$/, '') + '.js';
  }

  function getCartChangeUrl() {
    if (window.routes && window.routes.cart_change_url) return window.routes.cart_change_url;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + 'cart/change.js';
  }

  function getCartAddUrl() {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (url.indexOf('.js') === url.length - 3) return url;
    return url.replace(/\/$/, '') + '.js';
  }

  function isCodeskinStore() {
    return document.body && document.body.classList.contains('codeskin-store');
  }

  function ensureToast() {
    if (typeof window.showCodeskinCartToast === 'function') return;
    window.showCodeskinCartToast = function showCodeskinCartToast(message, type) {
      var existing = document.querySelector('.codeskin-cart-toast');
      if (existing) existing.remove();

      var toast = document.createElement('div');
      toast.className = 'codeskin-cart-toast codeskin-cart-toast--' + (type || 'success');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<span class="codeskin-cart-toast__icon" aria-hidden="true">' +
        (type === 'error' ? '!' : '✓') +
        '</span><span class="codeskin-cart-toast__text"></span>';
      toast.querySelector('.codeskin-cart-toast__text').textContent = message;
      document.body.appendChild(toast);

      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });

      window.setTimeout(function () {
        toast.classList.remove('is-visible');
        window.setTimeout(function () {
          toast.remove();
        }, 320);
      }, 3400);
    };
  }

  function formLooksLikeCartAdd(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = (form.getAttribute('action') || '').toLowerCase();
    var actionProp = '';
    try {
      actionProp = String(form.action || '').toLowerCase();
    } catch (err) {
      actionProp = '';
    }
    if (action.indexOf('/cart/add') !== -1 || actionProp.indexOf('/cart/add') !== -1) return true;
    if (form.querySelector('[name="id"]') && form.querySelector('[name="add"], [data-codeskin-add-btn], [data-add-to-cart], [data-codeskin-atc-submit]')) {
      return true;
    }
    return false;
  }

  function isManagedAtcForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.classList.contains('codeskin-pdp-form')) return true;
    if (!isCodeskinStore()) return false;
    if (formLooksLikeCartAdd(form)) return true;
    if (form.classList.contains('codeskin-collection-atc-form')) return true;
    if (form.classList.contains('product-card-atc-wrapper')) return true;
    if (form.classList.contains('product-form') && form.querySelector('[name="id"]')) return true;
    if (form.classList.contains('main-product-form') && form.querySelector('[name="id"]')) return true;
    if (form.closest('product-form-context') && form.querySelector('[name="id"]')) return true;
    return false;
  }

  function getPendingKey(form) {
    return form.id || form.getAttribute('data-product-id') || getVariantIdFromForm(form) || 'form';
  }

  function isPending(key) {
    return !!pendingKeys[key];
  }

  function setPending(key, value) {
    if (value) pendingKeys[key] = true;
    else delete pendingKeys[key];
  }

  function getVariantIdFromForm(form) {
    var input = form.querySelector('.variant-id-input') || form.querySelector('[name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function getQuantityFromForm(form) {
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    return qty;
  }

  function buildAddFormData(form) {
    var variantId = getVariantIdFromForm(form);
    if (!variantId) return null;
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', String(getQuantityFromForm(form)));
    return fd;
  }

  function getManagedAtcForms() {
    return Array.prototype.filter.call(document.querySelectorAll('form'), function (form) {
      return isManagedAtcForm(form);
    });
  }

  function storeButtonLabel(btn, attr) {
    if (!btn) return '';
    var stored = btn.getAttribute(attr);
    if (stored) return stored;
    var label = btn.textContent.trim() || 'Add';
    btn.setAttribute(attr, label);
    return label;
  }

  function markStandaloneButton(btn, inCart, options) {
    if (!btn) return;
    options = options || {};
    var defaultLabel = storeButtonLabel(btn, 'data-codeskin-add-label');
    var addedLabel =
      options.addedLabel || btn.getAttribute('data-codeskin-added-label') || 'Added';

    if (inCart) {
      btn.classList.add('is-added');
      btn.classList.remove('is-adding');
      btn.textContent = addedLabel;
      btn.setAttribute('aria-disabled', 'true');
      btn.disabled = false;
    } else {
      btn.classList.remove('is-added', 'is-adding');
      btn.textContent = defaultLabel;
      btn.removeAttribute('aria-disabled');
      btn.disabled = false;
    }
  }

  function applyStandaloneQtyWrap(btn, variantId, line) {
    var wrap =
      btn.parentElement && btn.parentElement.querySelector('[data-codeskin-card-qty]');
    if (!wrap) return;
    bindStandaloneQtyControls(wrap, variantId);
    var qty = line && line.quantity > 0 ? line.quantity : 0;
    var valueEl = wrap.querySelector('[data-codeskin-qty-value]');
    if (qty > 0) {
      btn.hidden = true;
      wrap.hidden = false;
      if (valueEl) valueEl.textContent = String(qty);
    } else {
      btn.hidden = false;
      wrap.hidden = true;
      if (valueEl) valueEl.textContent = '1';
    }
  }

  function bindStandaloneQtyControls(wrap, variantId) {
    if (wrap.dataset.qtyBound === 'true') return;
    wrap.dataset.qtyBound = 'true';
    var valueEl = wrap.querySelector('[data-codeskin-qty-value]');
    var minusBtn = wrap.querySelector('[data-codeskin-qty-minus]');
    var plusBtn = wrap.querySelector('[data-codeskin-qty-plus]');

    function currentQty() {
      return parseInt((valueEl && valueEl.textContent) || '1', 10) || 1;
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        changeVariantQuantity(variantId, currentQty() - 1);
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        changeVariantQuantity(variantId, currentQty() + 1);
      });
    }
  }

  function applyStandaloneButtons(cart) {
    var map = buildVariantMap(cart);
    document.querySelectorAll('[data-codeskin-atc-variant]').forEach(function (btn) {
      var variantId = btn.getAttribute('data-codeskin-atc-variant');
      var line = variantId ? map[String(variantId)] : null;
      if (btn.hasAttribute('data-codeskin-wishlist-atc')) {
        applyStandaloneQtyWrap(btn, variantId, line);
        return;
      }
      markStandaloneButton(btn, !!(line && line.quantity > 0));
    });

    document.querySelectorAll('[data-codeskin-fbt-atc]').forEach(function (btn) {
      var fbt = btn.closest('[data-codeskin-fbt]');
      if (!fbt) return;
      var raw = fbt.getAttribute('data-fbt-variants') || '';
      var ids = raw
        .split(',')
        .map(function (s) {
          return String(parseInt(s.trim(), 10));
        })
        .filter(function (id) {
          return id && id !== 'NaN';
        });
      if (!ids.length) return;
      var allInCart = ids.every(function (id) {
        return map[id] && map[id].quantity > 0;
      });
      markStandaloneButton(btn, allInCart, { addedLabel: 'Added to Cart' });
    });
  }

  function buildVariantMap(cart) {
    var map = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      map[String(item.variant_id)] = {
        quantity: item.quantity,
        key: item.key,
      };
    });
    return map;
  }

  function getFormCartEls(form) {
    return {
      addBtn:
        form.querySelector('[data-codeskin-add-btn]') ||
        form.querySelector('[data-codeskin-atc-submit]') ||
        form.querySelector('button[type="submit"][name="add"]') ||
        form.querySelector('button[type="submit"]') ||
        form.querySelector('.product-card-cart-btn[type="submit"]') ||
        form.querySelector('.product-card-cart-btn'),
      qtyWrap: form.querySelector('[data-codeskin-card-qty]'),
      qtyValue: form.querySelector('[data-codeskin-qty-value]'),
      minusBtn: form.querySelector('[data-codeskin-qty-minus]'),
      plusBtn: form.querySelector('[data-codeskin-qty-plus]'),
    };
  }

  function setQtyControlsDisabled(els, disabled) {
    [els.minusBtn, els.plusBtn, els.addBtn].forEach(function (btn) {
      if (btn) btn.disabled = !!disabled;
    });
  }

  function applyFormCartState(form, line) {
    var els = getFormCartEls(form);
    if (!els.addBtn && !els.qtyWrap) return;

    if (line && line.quantity > 0) {
      form.dataset.codeskinLineKey = line.key;
      if (els.qtyWrap) {
        if (els.addBtn) els.addBtn.hidden = true;
        els.qtyWrap.hidden = false;
        if (els.qtyValue) els.qtyValue.textContent = String(line.quantity);
        setQtyControlsDisabled(els, false);
      } else if (els.addBtn) {
        if (form.classList.contains('codeskin-pdp-form')) {
          var pdpLabel = els.addBtn.querySelector('[data-codeskin-atc-label]');
          els.addBtn.classList.add('is-added');
          els.addBtn.removeAttribute('disabled');
          els.addBtn.setAttribute('aria-disabled', 'true');
          if (pdpLabel) pdpLabel.textContent = 'Added to Cart';
        } else {
          markStandaloneButton(els.addBtn, true, {
            addedLabel: els.addBtn.getAttribute('data-codeskin-added-label') || 'Added',
          });
        }
      }
    } else {
      delete form.dataset.codeskinLineKey;
      if (els.qtyWrap) els.qtyWrap.hidden = true;
      if (els.qtyValue) els.qtyValue.textContent = '1';
      if (els.addBtn) {
        els.addBtn.hidden = false;
        if (form.classList.contains('codeskin-pdp-form')) {
          var pdpLabel = els.addBtn.querySelector('[data-codeskin-atc-label]');
          els.addBtn.classList.remove('is-added');
          els.addBtn.removeAttribute('aria-disabled');
          if (pdpLabel) pdpLabel.textContent = 'Add to Cart';
        } else {
          markStandaloneButton(els.addBtn, false);
        }
      }
      setQtyControlsDisabled(els, false);
    }
  }

  function applyCartToForms(cart) {
    lastCart = cart;
    var map = buildVariantMap(cart);
    getManagedAtcForms().forEach(function (form) {
      var variantId = getVariantIdFromForm(form);
      applyFormCartState(form, variantId ? map[variantId] : null);
    });
    applyStandaloneButtons(cart);
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function refreshCartBadge(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count === null) return;
    document.querySelectorAll('[data-cart-count], .cart-count, .cart-badge').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  function refreshCartUI(cart) {
    refreshCartBadge(cart);
    if (typeof fetchAjaxCartState === 'function' && typeof refreshAjaxCartUI === 'function') {
      return fetchAjaxCartState()
        .then(function (cartData) {
          refreshAjaxCartUI(cartData);
          return cartData;
        })
        .catch(function () {
          return cart;
        });
    }
    return Promise.resolve(cart);
  }

  function notifyCartUpdate(cart, variantId, source) {
    refreshCartBadge(cart);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: source || 'codeskin-cart',
        productVariantId: variantId || null,
        cartData: cart,
      });
    }
  }

  function showToast(message, type) {
    ensureToast();
    window.showCodeskinCartToast(message, type);
  }

  function getProductTitleForForm(form) {
    var card = form.closest('[data-product-card], .product--card, .product-card');
    var titleEl =
      (card && card.querySelector('.product--title, .product-title, h3, h4')) || null;
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function successToastForForm(form) {
    var productTitle = getProductTitleForForm(form);
    var toastMsg =
      window.codeskinCartStrings && window.codeskinCartStrings.added
        ? window.codeskinCartStrings.added
        : 'Added to your bag';
    if (productTitle) toastMsg = productTitle + ' - ' + toastMsg;
    showToast(toastMsg, 'success');
  }

  function changeLineQuantity(lineKey, quantity) {
    return fetch(getCartChangeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not update cart');
        }
        return data;
      });
    });
  }

  function changeVariantQuantity(variantId, newQuantity) {
    var id = String(variantId);
    var key = 'variant-' + id;
    if (isPending(key)) return Promise.resolve(null);
    setPending(key, true);

    return syncAddedFromCart()
      .then(function (cart) {
        var map = buildVariantMap(cart);
        var line = map[id];
        if (!line) {
          if (newQuantity > 0) {
            return addVariant(id, newQuantity);
          }
          return cart;
        }
        return changeLineQuantity(line.key, Math.max(0, newQuantity)).then(function () {
          return syncAddedFromCart();
        });
      })
      .then(function (cart) {
        if (cart) {
          refreshCartUI(cart);
          notifyCartUpdate(cart, id, 'codeskin-cart');
        }
        return cart;
      })
      .catch(function (err) {
        showToast(err.message || 'Could not update bag', 'error');
        return null;
      })
      .finally(function () {
        setPending(key, false);
      });
  }

  function syncAddedFromCart() {
    return fetch(getCartJsUrl(), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyCartToForms(cart);
        refreshCartBadge(cart);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function addVariant(variantId, quantity) {
    if (!variantId) {
      showToast('Please choose a variant', 'error');
      return Promise.resolve(null);
    }
    var key = 'variant-' + variantId;
    if (isPending(key)) return Promise.resolve(null);

    var qty = quantity && quantity > 0 ? quantity : 1;
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(qty));

    setPending(key, true);
    return fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Add to cart failed');
          }
          return data;
        });
      })
      .then(function () {
        showToast(
          (window.codeskinCartStrings && window.codeskinCartStrings.added) ||
            'Added to your bag',
          'success'
        );
        return syncAddedFromCart();
      })
      .then(function (cart) {
        if (cart) {
          refreshCartUI(cart);
          notifyCartUpdate(cart, String(variantId), 'codeskin-cart');
        }
        return cart;
      })
      .catch(function (err) {
        showToast(err.message || 'Could not add to bag', 'error');
        return null;
      })
      .finally(function () {
        setPending(key, false);
      });
  }

  function addFromForm(form) {
    if (!form || !isManagedAtcForm(form)) return Promise.resolve(null);

    var pendingKey = getPendingKey(form);
    if (isPending(pendingKey)) return Promise.resolve(null);

    var els = getFormCartEls(form);
    var btn = els.addBtn;
    var defaultLabel =
      (btn && btn.getAttribute('data-codeskin-add-label')) ||
      (btn && btn.textContent.trim()) ||
      'Add';
    if (btn && !btn.getAttribute('data-codeskin-add-label')) {
      btn.setAttribute('data-codeskin-add-label', defaultLabel);
    }

    var body = buildAddFormData(form);
    if (!body) {
      showToast('Please choose a variant', 'error');
      return Promise.resolve(null);
    }

    setPending(pendingKey, true);
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-adding');
      if (btn.hasAttribute('data-codeskin-add-btn')) {
        btn.textContent = 'Adding…';
      }
    }

    return fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Add to cart failed');
          }
          return data;
        });
      })
      .then(function () {
        successToastForForm(form);
        return syncAddedFromCart();
      })
      .then(function (cart) {
        if (cart) {
          refreshCartUI(cart);
          notifyCartUpdate(cart, getVariantIdFromForm(form), 'codeskin-cart');
        }
        return cart;
      })
      .catch(function (err) {
        showToast(err.message || 'Could not add to bag', 'error');
        if (btn) {
          btn.textContent = defaultLabel;
          btn.classList.remove('is-adding');
          btn.disabled = false;
        }
        return null;
      })
      .finally(function () {
        setPending(pendingKey, false);
        if (btn && !btn.hidden && !btn.classList.contains('is-added')) {
          btn.classList.remove('is-adding');
          btn.disabled = false;
          if (btn.hasAttribute('data-codeskin-add-btn')) {
            btn.textContent = defaultLabel;
          }
        }
      });
  }

  function addMultipleVariants(variantIds) {
    var ids = (variantIds || [])
      .map(function (id) {
        return parseInt(id, 10);
      })
      .filter(function (id) {
        return !isNaN(id) && id > 0;
      });
    if (!ids.length) return Promise.resolve(null);

    var key = 'bundle-' + ids.join('-');
    if (isPending(key)) return Promise.resolve(null);

    setPending(key, true);
    return fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: ids.map(function (id) {
          return { id: id, quantity: 1 };
        }),
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Add to cart failed');
          }
          return data;
        });
      })
      .then(function () {
        showToast('Bundle added to your bag', 'success');
        return syncAddedFromCart();
      })
      .then(function (cart) {
        if (cart) {
          refreshCartUI(cart);
          notifyCartUpdate(cart, String(ids[0]), 'codeskin-cart');
        }
        return cart;
      })
      .catch(function (err) {
        showToast(err.message || 'Could not add to bag', 'error');
        return null;
      })
      .finally(function () {
        setPending(key, false);
      });
  }

  function handleQtyAdjust(form, delta) {
    var pendingKey = getPendingKey(form) + '-qty';
    if (!form || isPending(pendingKey)) return;

    var lineKey = form.dataset.codeskinLineKey;
    var els = getFormCartEls(form);
    var current = parseInt(els.qtyValue && els.qtyValue.textContent, 10) || 1;
    var next = current + delta;
    if (next < 0) next = 0;

    if (!lineKey && delta > 0) {
      addFromForm(form);
      return;
    }

    if (!lineKey) return;

    setPending(pendingKey, true);
    setQtyControlsDisabled(els, true);
    if (els.qtyValue) els.qtyValue.textContent = String(Math.max(0, next));

    changeLineQuantity(lineKey, next)
      .then(function (cart) {
        applyCartToForms(cart);
        refreshCartUI(cart);
        notifyCartUpdate(cart, getVariantIdFromForm(form), 'codeskin-cart');
      })
      .catch(function (err) {
        showToast(err.message || 'Could not update bag', 'error');
        return syncAddedFromCart();
      })
      .finally(function () {
        setPending(pendingKey, false);
        setQtyControlsDisabled(getFormCartEls(form), false);
      });
  }

  function lockFormAgainstNativeSubmit(form) {
    if (!form || form.dataset.codeskinAtcLocked === 'true') return;
    form.dataset.codeskinAtcLocked = 'true';
    form.setAttribute('onsubmit', 'return false;');
    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      },
      true
    );
  }

  function guardCartPageNavigation(ms) {
    var duration = Math.max(400, parseInt(ms, 10) || 1200);
    var until = Date.now() + duration;
    var blocker = function (evt) {
      if (Date.now() > until) return;
      var link = evt.target && evt.target.closest ? evt.target.closest('a[href*="/cart"]') : null;
      if (!link) return;
      // Allow intentional cart-icon clicks only when not mid add-to-cart.
      if (link.closest('[data-source="cart-drawer"]') && !document.documentElement.classList.contains('codeskin-atc-busy')) {
        return;
      }
      evt.preventDefault();
      if (typeof evt.stopImmediatePropagation === 'function') evt.stopImmediatePropagation();
      evt.stopPropagation();
    };
    document.documentElement.classList.add('codeskin-atc-busy');
    document.addEventListener('click', blocker, true);
    window.setTimeout(function () {
      document.removeEventListener('click', blocker, true);
      document.documentElement.classList.remove('codeskin-atc-busy');
    }, duration + 50);
  }

  function onManagedFormSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') {
      form = event.target && event.target.closest ? event.target.closest('form') : null;
    }
    if (!form) return;

    // Always hard-block native /cart/add navigation for PDP.
    // PDP owns its own AJAX add via codeskin-pdp.js click handler.
    if (form.classList.contains('codeskin-pdp-form')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    if (!isManagedAtcForm(form) && !formLooksLikeCartAdd(form)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    lockFormAgainstNativeSubmit(form);
    guardCartPageNavigation(1400);
    addFromForm(form);
  }

  function onCollectionAddClick(event) {
    var addBtn = event.target.closest(
      '[data-codeskin-add-btn], button.product-card-cart-btn, .codeskin-card-add-btn'
    );
    if (!addBtn || addBtn.hidden || addBtn.disabled) return;
    if (addBtn.closest('[data-codeskin-card-qty]')) return;
    var form = addBtn.closest('form');
    if (!form || (!isManagedAtcForm(form) && !formLooksLikeCartAdd(form))) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    lockFormAgainstNativeSubmit(form);
    guardCartPageNavigation(1400);
    addFromForm(form);
  }

  function onBundleAtcClick(event) {
    var btn = event.target.closest('[data-cs-lp-routine-atc], [data-codeskin-bundle-atc]');
    if (!btn || btn.disabled) return;

    var host = btn.closest('[data-cs-lp-routine-checkout], [data-codeskin-bundle-atc-wrap]');
    var raw =
      (host && host.getAttribute('data-variant-ids')) ||
      btn.getAttribute('data-variant-ids') ||
      '';
    var variantIds = raw
      .split(',')
      .map(function (id) {
        return parseInt(String(id).trim(), 10);
      })
      .filter(function (id) {
        return !isNaN(id) && id > 0;
      });

    if (!variantIds.length) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    guardCartPageNavigation(1400);

    var defaultLabel = btn.getAttribute('data-codeskin-add-label') || btn.textContent.trim();
    if (!btn.getAttribute('data-codeskin-add-label')) {
      btn.setAttribute('data-codeskin-add-label', defaultLabel);
    }

    btn.disabled = true;
    btn.textContent = 'Adding…';

    addMultipleVariants(variantIds)
      .then(function (cart) {
        if (!cart) {
          btn.disabled = false;
          btn.textContent = defaultLabel;
          return;
        }
        btn.textContent = btn.getAttribute('data-codeskin-added-label') || 'Added to Cart';
        btn.disabled = false;
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = defaultLabel;
      });
  }

  document.addEventListener('submit', onManagedFormSubmit, true);
  document.addEventListener('click', onCollectionAddClick, true);
  document.addEventListener('click', onBundleAtcClick, true);

  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-codeskin-qty-minus]');
    var plus = event.target.closest('[data-codeskin-qty-plus]');
    var btn = minus || plus;
    if (!btn) return;

    var form = btn.closest('form.codeskin-collection-atc-form');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    handleQtyAdjust(form, plus ? 1 : -1);
  });

  document.addEventListener('click', function (event) {
    var atcBtn = event.target.closest('[data-codeskin-atc-variant]');
    if (!atcBtn || atcBtn.disabled) return;
    var variantId = atcBtn.getAttribute('data-codeskin-atc-variant');
    if (!variantId) return;
    event.preventDefault();
    event.stopPropagation();
    addVariant(variantId, 1);
  });

  document.addEventListener('click', function (event) {
    var sizeBtn = event.target.closest('.size-option-btn');
    if (!sizeBtn) return;
    window.setTimeout(function () {
      if (lastCart) applyCartToForms(lastCart);
    }, 60);
  });

  document.addEventListener('shopify:section:load', function () {
    syncAddedFromCart();
  });

  function boot() {
    ensureToast();
    document.querySelectorAll('form').forEach(function (form) {
      if (isManagedAtcForm(form) || formLooksLikeCartAdd(form) || form.getAttribute('data-codeskin-ajax-atc') === 'true') {
        lockFormAgainstNativeSubmit(form);
      }
    });
    syncAddedFromCart();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        syncAddedFromCart();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.codeskinCart = {
    addFromForm: addFromForm,
    addVariant: addVariant,
    addMultipleVariants: addMultipleVariants,
    applyCartToForms: applyCartToForms,
    syncAddedFromCart: syncAddedFromCart,
    applyFormCartState: applyFormCartState,
    isManagedAtcForm: isManagedAtcForm,
    guardCartPageNavigation: guardCartPageNavigation,
    changeVariantQuantity: changeVariantQuantity,
  };
})();
